export default __webpack_public_path__ + "static/media/cat.1b007d26.png";